"use strict";

exports.arrayBind = function (arr) {
  return function (f) {
    var result = [];
    for (var i = 0, l = arr.length; i < l; i++) {
      Array.prototype.push.apply(result, f(arr[i]));
    }
    return result;
  };
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-prelude/src/Control/Bind.js
// module id = 79
// module chunks = 0